import { useFormContext } from "react-hook-form";
import type { GridValidRowModel } from "@mui/x-data-grid-premium";
import type { SelectValueProp } from "src/system/system.types";
import { getResourceBySelectValue } from "src/system/getResourceBySelectValue";
import { getSelectValue } from "src/system/getSelectValue.ts";

export const useSelectFieldOnChange = <
  Resource extends GridValidRowModel = GridValidRowModel,
>({
  onChange: onChangeProp,
  isMultiple,
  name,
  valueProp,
}: {
  onChange?: (value: string, resource: any, form: any) => void;
  isMultiple?: boolean;
  valueProp?: SelectValueProp<Resource>;
  name: string;
}) => {
  const form = useFormContext();

  const handleChangeMultiple =
    ({
      onChange,
      resources,
    }: {
      onChange: (value: any) => void;
      resources: Resource[];
    }) =>
    (value: any) => {
      onChangeProp?.(
        value,
        [], // todo: resources
        form,
      );
      const prevResources = form.getValues(`${name}_resources`);
      if (prevResources) {
        if (Array.isArray(value)) {
          // recently added resource will be found
          const foundedResources = value
            .map((value) => {
              return getResourceBySelectValue({
                value: value,
                valueProp,
                resources,
              });
            })
            .filter(Boolean);

          const nextResources = value.map((value) => {
            return [...foundedResources, ...prevResources].find(
              (resource) =>
                getSelectValue({
                  item: resource,
                  valueProp,
                }) === value,
            );
          });
          form.setValue(
            `${name}_resources`,
            // @ts-ignore
            nextResources,
          );
        } else {
          form.setValue(
            `${name}_resources`,
            // @ts-ignore
            [],
          );
        }
      }

      onChange(value);
    };

  const handleChangeSingle =
    ({
      onChange,
      resources,
    }: {
      onChange: (value: any) => void;
      resources: Resource[];
    }) =>
    (value: any) => {
      const resource = getResourceBySelectValue({
        value,
        valueProp,
        resources,
      });
      onChangeProp?.(value, resource, form);
      const prevResources = form.getValues(`${name}_resources`);
      if (prevResources) {
        form.setValue(
          `${name}_resources`,
          // @ts-ignore
          [resource],
        );
      }
      onChange(value);
    };
  return isMultiple ? handleChangeMultiple : handleChangeSingle;
};
